import * as React from "react";
// UI Frameworks
import { Form, Button as AntButton } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Button from "components/Button";
import Input from "components/Input";
//Local components
import Counter from "screens/Auth/components/Counter";
//utilities and hooks
import useUser from "hooks/useUser";
// Services
import showNotify from "helpers/notify";
import { normalizeNumbers } from "helpers/persian";
import AuthService from "services/http/endpoints/auth";
//styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	mobile: string;
	onChangeMobile: () => void;
	onSubmit: (data: any) => void;
}

const CodeValidation: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;
	const [loading, setLoading] = React.useState(false);
	const [isTimerComplete, setIsTimerComplete] = React.useState(false);
	const { verifyActivationCode } = useUser();

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					const verified = await verifyActivationCode({
						mobile: props.mobile,
						code: values.code,
					});
					if (!verified) {
						showNotify({
							text: "کد تایید نامعتبر است.",
							duration: 3000,
						});
						setLoading(false);
					} else {
						props.onSubmit(values);
					}
				} catch (error) {
					setLoading(false);

					throw error;
				}
			}
		});
	}

	async function onCounterResend() {
		setIsTimerComplete(false);

		await AuthService.sendActivationCode(props.mobile);
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit} className={styles["code-validation"]}>
				<Form.Item>
					{getFieldDecorator("code", {
						normalize: normalizeNumbers,
						rules: [
							{
								required: true,
								transform: value => (value ? value.trim() : value),
								message: "لطفا کد تایید را وارد نمایید!",
							},
						],
					})(<Input placeholder="کد تایید" maxLength={5} />)}
				</Form.Item>
				<div style={{ height: 50 }}>
					{isTimerComplete ? (
						<Button
							primary
							ghost
							onClick={async () => {
								await onCounterResend();
							}}
						>
							ارسال مجدد کد پیامکی
						</Button>
					) : (
						<Counter counter={120} onFinished={() => setIsTimerComplete(true)} />
					)}
				</div>
				<AntButton type="link" style={{ padding: 0 }} onClick={props.onChangeMobile}>
					تغییر شماره موبایل
				</AntButton>
				<Form.Item className="button-center">
					<Button htmlType="submit" primary loading={loading}>
						تایید
					</Button>
				</Form.Item>
			</Form>
		</React.Fragment>
	);
};

export default Form.create<IProps>({ name: "CodeValidation" })(React.memo(CodeValidation));
